import VBasePopoverContext from './context';

export const useVBasePopoverContext = VBasePopoverContext.hook;
